// extracted by mini-css-extract-plugin
export default {"container":"LoginLogo_container__ggj3u"};